import _ from 'lodash'
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueCookie from 'vue-cookie'
import VueLazyload from 'vue-lazyload'
import GeoMap from './components/GeoMap'

import './map.css'
import './images/marker-highlight-icon.png'
import './images/marker-cadastre-icon.png'

const _searchResultTypes = [
    { name: 'SputnikShape', title: 'Адреса на карте', order: 900 },
    { name: 'RosreestrShape', title: 'Кадастр Росреестра', order: 901 },
];

Vue.use(VueResource);
Vue.use(VueCookie);
Vue.use(VueLazyload);

Vue.filter('fallback', function (value) {
    return (value || _.isNumber(value)) ? value : 'Неизвестно'
});

Vue.filter('date', function (value) {
    if (!_.isEmpty(value)) {
        let date = new Date(value);

        if (_.isFinite(date.getDate())) {
            return date.toLocaleDateString();
        }
    }

    return value;
});

Vue.filter('resultType', function (name) {
    let type = _.find(window.vm.$options.searchResultTypes, { name: name });
    return type ? type.title : name;
});

Vue.filter('resultOrder', function (name) {
    let type = _.find(window.vm.$options.searchResultTypes, { name: name });
    return type ? type.order : Number.MAX_SAFE_INTEGER;
});


Vue.filter('hectares', function (sqm) {
    return (sqm / 10000.0).toFixed(2) + ' га';
});

Vue.filter('km', function (m) {
    return (m / 1000.0).toFixed(2) + ' км';
});

window.bus = new Vue();

window.vm = new Vue({
    el: '#map',
    data: window.MapData,
    components: { 'geo-map': GeoMap },
    searchResultTypes: _searchResultTypes
});



// WEBPACK FOOTER //
// ./src/map.js